<template>
  <div id="massage-view">

    <!-- CONTENT -->

    <div id="wideContent">

      <div class="box">

        <div class="boxContent">

          <h1>Masáže psů</h1>

          <p>
            Salon Jája zavedl novou službu pro Vaše psí miláčky, a to regenerační masáže.
            Ty pomáhají řešit určité zdravotní problémy psa a zlepšují jeho celkový zdravotní stav i tělesnou kondici.
            Pozitivně působí na tělesné i psychické zdraví psů bez rozdílů věku a fyzického stavu.
          </p>

          <p><b>Upozornění:</b> před masáží 2 hodiny nepodávat stravu</p>

          <br />

          <p style="margin-bottom: 5px"><b>Masáže se vyznačují následujícími účinky:</b></p>
          <ul>
            <li>pomáhají zejména k zlepšení lymfatického a oběhového systému</li>
            <li>udržují vnitřní rovnováhu celého těla</li>
            <li>uvolňují svalová spazmata, křeče a srůsty</li>
            <li>uvolňují působení stresu a symptomů s ním spojených</li>
            <li>prokrvují kůži, udržují zdravou a zářivou srst</li>
            <li>rozrušují malé tukové útvary</li>
            <li>zlepšují elasticitu kůže</li>
          </ul>

          <br />
          <br />

          <p style="margin-bottom: 5px"><b>Masáže se však nedoporučují při:</b></p>
          <ul>
            <li>onemocnění psa</li>
            <li>infekci kůže</li>
            <li>otevřeném zranění</li>
            <li>dehydrataci  psa</li>
            <li>extrémním vyčerpání psa</li>
            <li>otocích a podlitinách</li>
          </ul>

        </div>
      </div>

      <div class="cleaner">
        <!-- / -->
      </div>

    </div>

    <!-- /CONTENT -->

  </div>
</template>

<script>
  export default {
    name: 'massage-view',
    head: {
      title: { inner: 'Psí Salon Jája', separator: '-', complement: 'masáže psů' },
      meta: [
        { id: 'description', content: 'Psí Salon Jája nabízí psí masáže, jež řeší určité zdravotní problémy psa a pomáhají zlepšit jeho celkový zdravotní stav.' },
        { id: 'keywords', content: 'psí masáže, masáže psů' }
      ]
    }
  }
</script>



// WEBPACK FOOTER //
// MassageView.vue?5be748db